import { AsyncAction } from '../../base-classes/asyncAction';
import { StoriesProvider } from '../providers/storiesProvider';
import { mapParamsToObject } from '../../utilities/mapParamsToObject';

export const GET_STORIES = new AsyncAction('GET_STORIES');
export const GET_STORIES_FEATURED = new AsyncAction('GET_STORIES_FEATURED');

export function getStories(...params) {

    let paramsObject = {
        baseUrl: undefined,
        path: undefined,
        authId: undefined,
        secret: undefined,
        stdParameters: undefined,
        verbose: undefined,
        category: undefined,
        includeVideos: undefined,
        recordsLimit: undefined
    };
    paramsObject = mapParamsToObject(params, paramsObject);
    return {
        type: paramsObject.category === 'featured' ? GET_STORIES_FEATURED.base : GET_STORIES.base,
        payload: getStoriesAction(paramsObject)
    };
}

async function getStoriesAction({ baseUrl, path, authId, secret, stdParameters, verbose, category, includeVideos, recordsLimit}) {
    const op = new StoriesProvider(baseUrl, authId, secret);
    return await op.getStories(stdParameters, path, verbose, category, includeVideos, recordsLimit);
}
